// react import
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useMedia } from 'react-media';
import { Outlet, useLocation } from 'react-router-dom';

// static
import { THEME, THEME_KEY } from './static/Theme';
import { LOCALE_DEFAULT, TIMEZONE_DEFAULT } from './static/Localization';
import { LOCALE_KEY, TIMEZONE_KEY } from './static/Constants';

// hooks
import { useLocalStorage } from './hooks/localStorage';

// context
import { ThemeContext } from 'context/Theme';
import { LocaleContext } from 'context/Locale';
import { TimezoneContext } from 'context/Timezone';

import LanguageProvider from 'common/provider/Language';

import { DrapDropPosWrap } from 'common/components';

import { GLOBAL_MEDIA_QUERIES } from 'static/MediaQuery';

// utils
import { initApp } from 'utils/common/init';
import useCloseDetail from 'hooks/useCloseDetail';
import { useInitApp } from 'hooks/useInitApp';

import './App.less';
import 'styles/media.less';
import 'styles/scroller.less';
import 'styles/agGridClient.less';
import 'styles/animation.less';
import 'themes/index';
import ErrorBoundary from 'common/components/errorboundary/ErrorBoundary';

import { NavigationEventListener } from 'routes/utils/NavigationEventListener';

import GlobalLoading from 'pages/loading/GlobalLoading';

function App(props) {
  const { messages } = props;
  const dispatch = useDispatch();

  const location = useLocation();

  const { closeDetailStackingProcess } = useCloseDetail();

  useEffect(() => {
    closeDetailStackingProcess(location);
  }, [location?.pathname, closeDetailStackingProcess]);

  // theme support
  const [theme, setTheme] = useLocalStorage(THEME_KEY, THEME.LIGHT);
  function toggleTheme(newTheme) {
    setTheme(newTheme);
  }

  // locale support
  const [locale, setLocale] = useLocalStorage(LOCALE_KEY, LOCALE_DEFAULT);
  const changeLocale = (newLocale) => {
    setLocale(newLocale);
  };

  // multiple timezone support
  const [timezone, setTimezone] = useLocalStorage(
    TIMEZONE_KEY,
    TIMEZONE_DEFAULT
  );

  const changeTimezone = (newTimezone) => {
    setTimezone(newTimezone);
  };

  const matches = useMedia({ queries: GLOBAL_MEDIA_QUERIES });

  useEffect(() => {
    if (matches.xs || matches.md || matches.lg) {
    }
  });

  useEffect(() => {
    initApp({ dispatch });
  }, [dispatch]);

  useInitApp();

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      <LocaleContext.Provider value={{ locale, changeLocale }}>
        <LanguageProvider messages={messages}>
          <TimezoneContext.Provider value={{ timezone, changeTimezone }}>
            <DrapDropPosWrap>
              <div className={props.cls} style={props.style}>
                <ErrorBoundary>
                  <NavigationEventListener />
                  <GlobalLoading>
                    <Outlet />
                  </GlobalLoading>
                </ErrorBoundary>
              </div>
            </DrapDropPosWrap>
          </TimezoneContext.Provider>
        </LanguageProvider>
      </LocaleContext.Provider>
    </ThemeContext.Provider>
  );
}

export default App;
